export default [
  {
    path: '/form-builder/templates',
    name: 'form-template-list',
    component: () => import('@/views/form-builder/Template/TemplateList.vue'),
    meta: {
      layout: 'content',
      app: 'formBuilder',
      appId: 12,
    },
  },

  {
    path: '/form-builder/templates/:uuid/edit',
    name: 'manage-template',
    component: () => import('@/views/form-builder/Template/TemplateList.vue'),
    meta: {
      layout: 'content',
      app: 'formBuilder',
      appId: 12,
    },
  },

  {
    path: '/form-builder/published-list',
    name: 'published-template-list',
    component: () => import('@/views/form-builder/Form/PublishedTemplateList.vue'),
    meta: {
      layout: 'content',
      app: 'formBuilder',
      appId: 12,
    },
  },

  {
    path: '/form-builder/:uuid/list',
    name: 'form-list',
    component: () => import('@/views/form-builder/Form/FormsList.vue'),
    meta: {
      layout: 'content',
      app: 'formBuilder',
      appId: 12,
    },
  },

  {
    path: '/form-builder/shared/forms/list',
    name: 'shared-form-list',
    component: () => import('@/views/form-builder/Form/SharedFormList.vue'),
    meta: {
      layout: 'content',
      app: 'formBuilder',
      appId: 12,
    },
  },

]
